module.exports = __webpack_public_path__ + "static/scopriabitareco_experiences_virtualreality-68c7d3af792f0ff0ead02dd64a8b0c6b.jpg";